import { yupResolver } from "@hookform/resolvers/yup";
import { MediaDirectoryKeys } from "constants/enums";
import { useDirectUploadToS3 } from "libs/directUpload";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, Input, RichTextEditor, Switch } from "ui";

import { usageGuideFaqItemSchema } from "../../../helpers";
import {
  UsageGuideFaqItemFormProps,
  UsageGuideFaqItemFormValues
} from "./UsageGuideFaqItemForm.types";

import styles from "./UsageGuideFaqItemForm.module.scss";

const UsageGuideFaqItemForm = ({
  formId,
  defaultValues,
  onSubmit
}: UsageGuideFaqItemFormProps) => {
  const { t } = useTranslation();
  const { uploader } = useDirectUploadToS3();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<UsageGuideFaqItemFormValues>({
    resolver: yupResolver(usageGuideFaqItemSchema),
    defaultValues
  });

  const handleUploadImage = async (file: File): Promise<string | null> => {
    const media = await uploader(file, {
      directoryKey: MediaDirectoryKeys.ProductUsageGuide
    });

    return media?.url ?? null;
  };

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <Input
        {...register("question")}
        label={t("Question")}
        placeholder={t("Enter Question")}
        errorMessage={errors.question?.message}
      />

      <Controller
        control={control}
        name="answer"
        render={({ field: { value, onChange } }) => (
          <RichTextEditor
            defaultValue={value}
            onChange={(nextValue) => onChange(nextValue)}
            label={t("Answer")}
            errorMessage={errors.answer?.message}
            onUploadImage={handleUploadImage}
          />
        )}
      />

      <Controller
        control={control}
        name="isEnabled"
        render={({ field: { value, onChange } }) => (
          <FormField label={t("Visible to customers and to the assistant")}>
            <div className={styles.form_switch}>
              <Switch checked={value} onChange={onChange} />
            </div>
          </FormField>
        )}
      />
    </form>
  );
};

export default UsageGuideFaqItemForm;
